import type { Components } from '@mui/material/styles';

export default function MuiBottomNavigation(): Components['MuiBottomNavigation'] {
  return {};
}
